<template>
  <div class="servicematterin">
    <div style="padding: 0.2em 1.4em; margin-top: -17px">
      <el-form
        :model="serviceInForm"
        :rules="rules"
        ref="serviceInForm"
        label-width="100px"
      >
        <el-form-item label="公司名称" prop="company_name">
          <el-select
            v-model="serviceInForm.company_name"
            filterable
            remote
            reserve-keyword
            size="mini"
            clearable
            :remote-method="searchRemoteCompanyMethod"
            :loading="searchLoading"
            @change="getComUser"
            style="width: 100%"
            disabled
          >
            <el-option
              v-for="searchCompany in searchCompanies"
              :key="searchCompany.id"
              :label="searchCompany.company_name"
              :value="searchCompany.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="完成时间" prop="completed_at">
          <el-date-picker
            v-model="serviceInForm.completed_at"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="typeInPickerOptions"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
            size="mini"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="事项类型" prop="type">
          <el-checkbox
            v-model="serviceInForm.type"
            size="mini"
            label="w"
            border
            @change="clearNot"
            >是否包含外勤</el-checkbox
          >
        </el-form-item>
        <el-form-item label="紧急程度" prop="urgent">
          <el-radio-group v-model="serviceInForm.urgent" size="mini">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="2">紧急</el-radio-button>
            <el-radio-button label="3">非常紧急</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="难易程度" prop="easy">
          <el-radio-group v-model="serviceInForm.easy" size="mini">
            <el-radio-button label="1">容易</el-radio-button>
            <el-radio-button label="2">正常</el-radio-button>
            <el-radio-button label="3">困难</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="事项分类" prop="categoryId">
          <el-select
            v-model="serviceInForm.categoryId"
            placeholder="请选择"
            clearable
            filterable
            size="mini"
            style="width: 100%"
            @click.native="loadCategory"
            @change="loadTitle"
          >
            <el-option
              v-for="item in categoryIdOptions"
              :key="item.id"
              :label="item.category_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事项内容" prop="title">
          <el-select
            v-model="serviceInForm.title"
            placeholder="请选择"
            multiple
            clearable
            filterable
            size="mini"
            style="width: 100%"
            @change="changeTitle"
          >
            <!-- @click.native="loadTitle" -->
            <el-option
              v-for="item in titleIdOptions"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内部可见" prop="detail_in">
          <el-input
            size="mini"
            type="textarea"
            v-model="serviceInForm.detail_in"
            placeholder="内容详情"
            style="white-space: pre"
          ></el-input>
        </el-form-item>
        <el-form-item label="外部可见" prop="detail_out">
          <el-input
            size="mini"
            type="textarea"
            v-model="serviceInForm.detail_out"
            placeholder="内容详情"
            style="white-space: pre"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否分配" prop="is_dis">
          <el-checkbox
            v-model="serviceInForm.is_dis"
            size="mini"
            label="now"
            border
            @change="doSomeThing"
            >现在分配</el-checkbox
          >
        </el-form-item>
        <el-form-item
          label="办理人"
          prop="doner_id"
          v-if="serviceInForm.is_dis && !serviceInForm.type"
        >
          <el-select
            v-model="serviceInForm.doner_id"
            placeholder="请选择"
            size="mini"
            @click.native="loadAdminUser"
            filterable
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in adminUserOptions"
              :key="item.id"
              :label="item.username"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
            label="办理人"
            prop="doner_id_n"
            v-if="serviceInForm.is_dis && serviceInForm.type"
          >
            <el-select
              v-model="serviceInForm.doner_id_n"
              placeholder="请选择"
              size="mini"
              @click.native="loadAdminUser"
              filterable
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in adminUserOptions"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        <el-form-item
          label="外勤办理人"
          prop="doner_id_w"
          v-if="serviceInForm.type && serviceInForm.is_dis"
        >
          <el-select
            v-model="serviceInForm.doner_id_w"
            placeholder="请选择"
            size="mini"
            @click.native="loadAdminUserForW"
            filterable
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in adminUserOptions_w"
              :key="item.id"
              :label="item.username"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="办事地点"
          prop="address"
          v-if="serviceInForm.type && serviceInForm.is_dis"
        >
          <el-select
            v-model="serviceInForm.address"
            placeholder="请选择"
            size="mini"
            @click.native="loadPlace"
            filterable
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in placeOptions"
              :key="item.id"
              :label="item.places_title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事项备注" prop="remark">
          <el-input
            size="mini"
            type="textarea"
            v-model="serviceInForm.remark"
            placeholder="内容详情"
          ></el-input>
        </el-form-item>
        <el-form-item label="补充信息">
          <el-collapse v-model="activeNames_in">
            <el-collapse-item title="" name="1">
              <template slot="title">
                <span style="color: #409eff">点击打开/隐藏</span>
              </template>
              <el-form-item label="订单号" prop="order_num">
                <el-input
                  v-model="serviceInForm.order_num"
                  size="mini"
                  placeholder="请输入订单号"
                  @input="getOrder"
                ></el-input>
                <el-row v-if="orderData" :gutter="0">
                  <el-row>
                    <el-col>
                      <span>订单号：</span>
                      <span style="color: #409eff">{{
                        this.orderData.order_num
                      }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span>创建时间：</span>
                      <span>{{ this.orderData.created_at }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span>订单类型：</span>
                      <span style="color: #e6a23c">{{
                        this.orderData.order_type
                      }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span>转化人：</span>
                      <span style="color: #67c23a">{{
                        this.orderData.convert_name
                      }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span>订单总金额：</span>
                      <span style="color: #f56c6c">{{
                        this.orderData.total_amount
                      }}</span>
                    </el-col>
                  </el-row>
                </el-row>
              </el-form-item>
              <el-form-item label="快递单号" prop="exp_num">
                <el-input
                  v-model="serviceInForm.exp_num"
                  size="mini"
                  placeholder="请输入快递单号"
                  @input="getExp"
                ></el-input>
                <el-row v-if="expData" :gutter="0">
                  <el-row>
                    <el-col :span="24">
                      <span>快递单号：</span>
                      <span style="color: #409eff">{{
                        this.expData.exp_num
                      }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span>录入时间：</span>
                      <span>{{ this.expData.created_at }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span>录入方式：</span>
                      <span style="color: #e6a23c">{{
                        this.expData.type
                      }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <span>录入人：</span>
                      <span style="color: #67c23a">{{
                        this.expData.exp_typeiner
                      }}</span>
                    </el-col>
                  </el-row>
                </el-row>
              </el-form-item>
              <el-form-item label="快递公司" prop="exp_company">
                  <el-select
                    v-model="serviceInForm.exp_company"
                    placeholder="请选择快递公司"
                    size="mini"
                    style="width: 100%"
                    filterable
                    clearable
                  >
                    <el-option value="SFEXPRESS" label="顺丰"></el-option>
                    <el-option value="STO" label="申通"></el-option>
                    <el-option value="YTO" label="圆通"></el-option>
                    <el-option value="ZTO" label="中通"></el-option>
                    <el-option value="HTKY" label="汇通"></el-option>
                    <el-option value="YUNDA" label="韵达"></el-option>
                    <el-option value="TTKDEX" label="天天"></el-option>
                    <el-option value="JD" label="京东快递"></el-option>
                    <el-option value="ZJS" label="宅急送"></el-option>
                    <el-option value="CHINAPOST" label="EMS"></el-option>
                    <el-option value="INTMAIL" label="EMS国际"></el-option>
                    <el-option value="DEPPON" label="德邦"></el-option>
                    <el-option value="HTKY" label="百世快递"></el-option>
                    <el-option value="JITU" label="极兔速递"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机号" prop="exp_phone" :inline-message="true">
                  <el-input
                    v-model="serviceInForm.exp_phone"
                    size="mini"
                    placeholder="请输入"
                    maxlength="11"
                    show-word-limit
                    clearable
                  ></el-input>
                </el-form-item>
              <el-form-item label="客户" prop="customer_name">
                <el-input
                  v-model="serviceInForm.customer_name"
                  size="mini"
                  placeholder="选择公司自动添加"
                  disabled
                ></el-input>
                <!-- @input="getCustomer" -->
                <!-- <el-row v-if="customerData" :gutter="0">
              <el-row>
                <el-col :span="24">
                  <span>客户ID：</span>
                  <span style="color: #409eff">{{ this.customerData.id }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>客户昵称：</span>
                  <span style="color: #e6a23c">{{
                    this.customerData.name
                  }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span>性别：</span>
                  <span style="color: #67c23a">{{
                    this.customerData.sex
                  }}</span>
                </el-col>
              </el-row>
            </el-row> -->
              </el-form-item>
              <el-form-item label="共享人" prop="share_id">
                <el-select
                  v-model="serviceInForm.share_id"
                  multiple
                  placeholder="请选择"
                  size="mini"
                  @click.native="loadShare"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in shareOptions"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-collapse-item>
          </el-collapse>
        </el-form-item>
        <el-form-item label="上传截图/文件" prop="url">
          <el-upload
            action="https://weixin.qiyehuo.com/api/servicein/upfile"
            :headers="headers"
            multiple
            ref="uploadMutiple"
            :file-list="fileList"
            :limit="limit"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess"
            :on-change="handleAvatarChange"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
          >
            <el-button size="mini" type="primary">点击上传</el-button>
            <div
              slot="tip"
              class="el-upload__tip"
              style="color: #909399; margin-top: -0.1rem"
            >
              单次上传最多10个文件或图片
            </div>
          </el-upload>
          <!-- <ul>
              <li v-for="item in fileNameList" :key="item" :title="item"><span class="notOver">{{item}}</span></li>
            </ul> -->
          <div style="margin-top: 0.2rem">
            <span
              ><i class="el-icon-s-opportunity" style="color: #fb894c"
                >点击下方，Ctrl+v上传</i
              ></span
            >
          </div>
          <!-- <div id="preview" @paste="handlePaste">
              <el-input
                size="mini"
                type="textarea"
                placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
                max="0"
              ></el-input>
            </div> -->
          <div
            id="preview"
            @paste="handlePaste"
            style="
              border: 3px dashed #409eff;
              border-radius: 15px;
              text-indent: 2em;
            "
          >
            <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
          </div>
        </el-form-item>
        <div style="text-align: right">
          <el-button
            type="primary"
            size="mini"
            @click="submitForm('serviceInForm')"
            >添加</el-button
          >
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceMatterIn',
  props: {
    companyId: Number,
    companyName: String
  },
  data () {
    var checkPhone = (rule, value, callback) => {
      if (value !== '') {
        var reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输⼊有效的⼿机号码'))
        }
      }
      callback()
    }
    return {
      activeNames_in_edit: [],
      activeNames_in: [],
      watchDetail_in_arr_edit: [],
      idForEdit: null,
      change: false,
      drawerTitle: '',
      sharerOptions: [],
      activeNames: ['2'],
      adminUserOptions_w: [],
      serviceInDrawer: false,
      searchLoading: false,
      companyInfoDrawer: false,
      editDrawer: false,
      distributeDrawer: false,
      searchForm: {
        companyId: '',
        typeiner_id: '',
        doner_id: '',
        dis_id: '',
        progress: '',
        status: '',
        handle_at: '',
        created_at: '',
        category_id: '',
        schedule_id: '',
        share_id: ''
      },
      distributeForm: {
        company_name: '',
        handle_at: '',
        doner_id: '',
        address: '',
        remark: '',
        doner_id_w: ''
      },
      serviceInForm: {
        doner_id_n: '',
        exp_company: '',
        exp_phone: '',
        is_dis: '',
        company_id: '',
        company_name: '',
        order_num: '',
        completed_at: '',
        type: '',
        categoryId: '',
        title: [],
        detail_in: '',
        detail_out: '',
        cate: {},
        title_name: '',
        share_id: '',
        exp_num: '',
        customer_id: '',
        customer_name: '',
        urgent: '',
        easy: '',
        doner_id: '',
        address: '',
        remark: '',
        doner_id_w: ''
      },
      editForm: {
        is_dis: '',
        company_id: '',
        order_num: '',
        completed_at: '',
        type: '',
        categoryId: '',
        title: [],
        detail_in: '',
        detail_out: '',
        cate: {},
        title_name: '',
        share_id: '',
        exp_num: '',
        customer_id: '',
        customer_name: '',
        urgent: '',
        easy: '',
        doner_id: '',
        address: '',
        remark: '',
        doner_id_w: ''
      },
      headers: {
        Authorization: localStorage.getItem('token')
      },
      limit: 10,
      orderData: '',
      judgeType: '',
      companyComId: null,
      total: 0,
      npage: 1,
      nowPage: 1,
      valuePerPage: 10,
      needUrl: [],
      category_idOptions: [],
      schedule_idOptions: [],
      fileNameList: [],
      header: [],
      expData: null,
      fileList: [],
      shareOptions: [],
      customerData: null,
      typeinerOptions: [],
      donerOptions: [],
      diserOptions: [],
      searchCompaniesx: [],
      searchCompanies: [],
      categoryIdOptions: [],
      titleIdOptions: [],
      watchDetail_in_arr: [],
      serviceInData: [],
      adminUserOptions: [],
      placeOptions: [],
      rules: {
        exp_phone: [
          {
            validator: checkPhone,
            trigger: 'blur'
          }
        ],
        company_id: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        completed_at: [
          { required: true, message: '请输入完成时间', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请选择事项分类', trigger: 'blur' }
        ],
        title: [{ required: true, message: '请选择事项内容', trigger: 'blur' }],
        detail_in: [
          { max: 2000, message: '长度最多2000个字符', trigger: 'blur' }
        ],
        detail_out: [
          { max: 2000, message: '长度最多2000个字符', trigger: 'blur' }
        ],
        order_num: [
          { max: 255, message: '长度最多255个字符', trigger: 'blur' }
        ],
        doner_id: [
          { required: true, message: '请选择办理人', trigger: 'blur' }
        ],
        doner_id_w: [
          { required: true, message: '请选择办理人(外勤)', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请选择办事地点', trigger: 'blur' }
        ]
      },
      rules_edit: {
        company_id: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        completed_at: [
          { required: true, message: '请输入完成时间', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请选择事项分类', trigger: 'blur' }
        ],
        title: [{ required: true, message: '请选择事项内容', trigger: 'blur' }],
        detail_in: [
          { max: 2000, message: '长度最多2000个字符', trigger: 'blur' }
        ],
        detail_out: [
          { max: 2000, message: '长度最多2000个字符', trigger: 'blur' }
        ],
        order_num: [{ max: 255, message: '长度最多255个字符', trigger: 'blur' }]
        // doner_id: [
        //   { required: true, message: '请选择办理人', trigger: 'blur' }
        // ],
        // doner_id_w: [
        //   { required: true, message: '请选择办理人(外勤)', trigger: 'blur' }
        // ],
        // address: [
        //   { required: true, message: '请选择办事地点', trigger: 'blur' }
        // ]
      },
      typeInPickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      },
      pickerOptionsDis: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      },
      searchPickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  methods: {
    loadCategory_id () {
      this.$axios
        .get('api/schedule/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.category_idOptions = data.data
          }
        })
        .catch()
    },
    loadSchedule_id () {
      this.$axios
        .get('api/servicein/gettitle')
        .then(({ data }) => {
          if (data.code === 1) {
            this.schedule_idOptions = data.data
          }
        })
        .catch()
    },
    // 监听粘贴操作
    handlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        // if (items[i].type.indexOf('image') !== -1) {
        file = items[i].getAsFile()
        // break
        // }
      }
      // if (!file) {
      //   this.$message.error('粘贴内容非图片')
      //   return
      // }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
        return
      }
      this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit() // 提交图片上传队列
    },
    handleRemove (file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1)
        }
      })
      this.fileList = fileList
      this.change = true
    },
    handlePictureCardPreview (file) {
      this.fileNameList = file.name
    },
    handleAvatarChange (res, file) {
      this.fileList = file
      this.change = true
    },
    handleAvatarSuccess (res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload (file) {
      // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt100M = file.size / (1024 * 100) < 100

      // if (!isJPG) {
      //   this.$message.error('上传图片格式为JPG或PNG!')
      //   return
      // }
      if (!isLt100M) {
        this.$message.error('上传总大小不能超过 100MB!')
        return false
      }
      // return isJPG && isLt2M
    },
    getCustomer (val) {
      if (val.length === 0) return false
      this.$axios
        .get('api/servicein/getcustomer?user_id=' + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.customerData = data.data
          }
        })
        .catch()
    },
    getExp (val) {
      if (val.length === 0) return false
      this.$axios
        .get('api/servicein/getexp?exp_num=' + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.expData = data.data
          }
        })
        .catch()
    },
    getOrder (val) {
      if (val.length === 0) return false
      this.$axios
        .get('api/servicein/getorder?order_num=' + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.orderData = data.data
          }
        })
        .catch()
    },
    serviceIn () {
      this.serviceInDrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$refs.serviceInForm.resetFields()
          this.orderData = null
          this.expData = null
          this.customerData = null
          this.fileList = []
          this.change = false
          done()
        })
        .catch(_ => {})
    },
    handleClose_edit (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.$refs.editForm.resetFields()
          this.orderData = null
          this.expData = null
          this.customerData = null
          this.fileList = []
          this.change = false
          done()
        })
        .catch(_ => {})
    },
    searchRemoteCompanyMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchArrItemCompanys(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
        }
      })
    },
    loadCategory () {
      this.$axios
        .get('api/schedule/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryIdOptions = data.data
          }
        })
        .catch()
    },
    loadTitle (id, ifChange) {
      this.titleIdOptions = []
      this.serviceInForm.title = []
      this.serviceInForm.detail_in = ''
      if (ifChange) {
        this.editForm.title = []
        this.editForm.detail_in = ''
      }
      if (id) {
        this.$axios
          .get('api/servicein/gettitle?cate_id=' + id)
          .then(({ data }) => {
            if (data.code === 1) {
              this.titleIdOptions = data.data
            }
          })
          .catch()
      }
    },
    changeTitle (val) {
      this.watchDetail_in_arr = []
      val.map(item => {
        this.titleIdOptions.map(i => {
          if (i.id === item) {
            this.watchDetail_in_arr.push(i.title + ':' + '\n')
          }
        })
      })
    },
    changeTitle_edit (val) {
      this.watchDetail_in_arr_edit = []
      val.map(item => {
        this.titleIdOptions.map(i => {
          if (i.id === item) {
            this.watchDetail_in_arr_edit.push(i.title + ':' + '\n')
          }
        })
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.serviceInForm.file = this.needUrl
          this.$axios
            .post('api/servicein/store', this.serviceInForm)
            .then(({ data }) => {
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.$refs.serviceInForm.resetFields()
                this.orderData = null
                this.expData = null
                this.customerData = null
                this.fileList = []
                this.serviceInDrawer = false
                this.$emit('close')
                this.change = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    openCompanyCom (row) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyComId = row.company_id
      })
    },
    loadTable () {
      this.$axios
        .get(
          'api/servicein/index?page=' +
            this.npage +
            '&perPage=' +
            this.valuePerPage,
          {
            params: this.searchForm
          }
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.serviceInData = data.data.data
            this.total = data.data.total
            this.header = data.count
          }
        })
        .catch()
    },
    handleSizeChange (val) {
      this.valuePerPage = val
      this.loadTable()
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    openEdit (row) {
      this.idForEdit = row.id
      this.editDrawer = true
      this.searchCompanies.push(row.company)
      this.editForm.company_id = row.company_id
      this.editForm.order_num = row.order_num
      this.editForm.exp_num = row.exp_num
      this.editForm.customer_name = row.customer ? row.customer.name : '暂无'
      this.editForm.completed_at = row.completed_at
      this.editForm.type = row.type === 'n' ? 0 : true
      this.editForm.urgent = row.urgent
      this.editForm.easy = row.easy
      this.categoryIdOptions.push(row.category)
      this.editForm.categoryId = row.categoryId
      this.titleIdOptions = row.schedule
      this.editForm.title = row.title
      this.editForm.detail_in = row.detail_in
      this.editForm.detail_out = row.detail_out
      if (row.share_id) {
        this.shareOptions = row.share
        this.editForm.share_id = row.share_id
      }
      if (row.doner_id) {
        this.adminUserOptions.push(row.donner)
        this.editForm.doner_id = row.doner_id
      }
      if (row.type === 'w') {
        if (row.doner_id_w) {
          this.adminUserOptions_w.push(row.donner_w)
          this.editForm.doner_id_w = row.doner_id_w
        }
        if (row.address) {
          this.placeOptions.push(row.place)
          this.editForm.address = row.address
        }
      }
      this.editForm.remark = row.remark
      this.fileList = row.screen
      this.needUrl = row.screen
      this.loadTitle(this.editForm.categoryId)
    },
    submitForm_edit (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editForm.file = this.needUrl
          this.editForm.id = this.idForEdit
          var oldId = this.fileList.map(item => {
            return item.id
          })
          this.editForm.oldId = oldId
          this.editForm.change = this.change
          this.$axios
            .put('api/outdis/edit', this.editForm)
            .then(({ data }) => {
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.editDrawer = false
                this.change = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    openDistribute (id, companyName, type) {
      this.loadAdminUserForW()
      this.judgeType = type
      this.distributeDrawer = true
      this.distributeForm.company_name = companyName
      this.$axios
        .get('api/servicein/showdis?id=' + id)
        .then(({ data }) => {
          if (data.code === 1) {
            if (data.data.doner) {
              this.adminUserOptions = [data.data.doner]
              this.distributeForm = data.data
              this.distributeForm.company_name = companyName
            } else {
              this.distributeForm.company_name = companyName
              this.distributeForm.id = id
            }
            if (data.data.place) {
              this.placeOptions = [data.data.place]
              this.distributeForm = data.data
              this.distributeForm.company_name = companyName
            } else {
              this.distributeForm.company_name = companyName
              this.distributeForm.id = id
            }
          }
        })
        .catch()
    },
    handleCloseDis (done) {
      this.$refs.distributeForm.resetFields()
      this.adminUserOptions = []
      this.diserOptions = []
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    loadAdminUser () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions = data.data
          }
        })
        .catch()
    },
    loadAdminUserForW () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.adminUserOptions_w = data.data
          }
        })
        .catch()
    },
    loadShare () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.shareOptions = data.data
          }
        })
        .catch()
    },
    loadTypeiner () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.typeinerOptions = data.data
          }
        })
        .catch()
    },
    loadDoner () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.donerOptions = data.data
          }
        })
        .catch()
    },
    loadDiser () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.diserOptions = data.data
          }
        })
        .catch()
    },
    loadSharer () {
      this.$axios
        .get('api/expmanage/getreceiver')
        .then(({ data }) => {
          if (data.code === 1) {
            this.sharerOptions = data.data
          }
        })
        .catch()
    },
    loadPlace () {
      this.$axios
        .get('api/outdis/getplace')
        .then(({ data }) => {
          if (data.code === 1) {
            this.placeOptions = data.data
          }
        })
        .catch()
    },
    submitDisForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/ysy/outdis/distribute', this.distributeForm)
            .then(({ data }) => {
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.$refs.distributeForm.resetFields()
                this.distributeDrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    searchRemoteCompanyMethodS (query) {
      if (query !== '') {
        this.searchLoading = true
        this.searchArrItemCompanysx(query)
        setTimeout(() => {
          this.searchLoading = false
        }, 200)
      } else {
        this.searchCompaniesx = []
      }
    },
    searchArrItemCompanysx (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompaniesx = data.data.companies
        }
      })
    },
    toSearch (val) {
      this.npage = 1
      this.loadTable()
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    doSearch () {
      this.npage = 1
      this.loadTable()
    },
    toLoadTable () {
      this.npage = 1
      this.loadTable()
    },
    clearNot (val) {
      if (!val) {
        this.serviceInForm.doner_id_w = ''
        this.serviceInForm.address = ''
      }
    },
    doSomeThing (val) {
      if (!val) {
        this.serviceInForm.doner_id = ''
        this.serviceInForm.doner_id_w = ''
        this.serviceInForm.address = ''
      }
    },
    doSomeThing_edit (val) {
      if (!val) {
        this.editForm.doner_id = ''
        this.editForm.doner_id_w = ''
        this.editForm.address = ''
      }
    },
    getComUser (val) {
      if (val) {
        this.$axios
          .get('api/servicein/getcomuser?company_id=' + val)
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.serviceInForm.customer_name = data.data[1]
              this.serviceInForm.customer_id = data.data[0]
            }
          })
      }
    }
  },
  watch: {
    watchDetail_in_arr: function (n, old) {
      this.serviceInForm.detail_in = n.join('')
      this.serviceInForm.detail_out = n.join('')
    },
    watchDetail_in_arr_edit: function (n, old) {
      this.editForm.detail_in = n.join('')
      this.editForm.detail_out = n.join('')
    },
    companyId: function (val) {
      this.serviceInForm.company_id = null
      this.serviceInForm.company_id = val
      if (val) this.getComUser(val)
    },
    companyName: function (val) {
      this.serviceInForm.company_name = null
      this.serviceInForm.company_name = val
    }
  }
}
</script>

<style scoped>
.notOver {
  display: block;
  width: 3rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/common/ServiceMatterIn.vue